document.addEventListener('DOMContentLoaded', function () {
  const productLoop = document.querySelector('.product-loop');
  const pagination = document.querySelector('#pagination');

  if (!productLoop || !pagination) return;

  let nextLink = pagination.querySelector('a.next-page');
  let loading = false;

  const loader = document.createElement('div');
  loader.id = 'nef-infinite-loader';
  loader.style.textAlign = 'center';
  loader.style.padding = '30px 0';
  loader.style.fontSize = '14px';
  loader.style.display = 'none';
  const headerLogo = document.querySelector('#logo img');

if (headerLogo) {
  const loadingLogo = headerLogo.cloneNode(true);
  loadingLogo.removeAttribute('id');
  loadingLogo.style.width = '90px';
  loadingLogo.style.height = 'auto';
  loadingLogo.style.animation = 'nefLogoPulse 1.1s ease-in-out infinite';

  loader.innerHTML = '';
  loader.appendChild(loadingLogo);
}if (!document.getElementById('nef-loader-style')) {
  const style = document.createElement('style');
  style.id = 'nef-loader-style';
  style.textContent = `
    @keyframes nefLogoPulse {
      0%, 100% {
        opacity: 0.35;
        transform: scale(0.92);
      }
      50% {
        opacity: 1;
        transform: scale(1);
      }
    }

    #nef-infinite-loader {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 80px;
      width: 100%;
    }
  `;
  document.head.appendChild(style);
}

  pagination.parentNode.insertBefore(loader, pagination);

  async function loadMoreProducts() {
    if (loading || !nextLink) return;

    loading = true;
    loader.style.display = 'block';

    try {
      const response = await fetch(nextLink.href, {
        credentials: 'same-origin'
      });

      if (!response.ok) throw new Error('Failed to load next page');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newProducts = doc.querySelectorAll('.product-loop .product-index');
      const newPagination = doc.querySelector('#pagination');

      newProducts.forEach(function (product) {
        productLoop.appendChild(product);
      });

      if (newPagination) {
        const newNextLink = newPagination.querySelector('a.next-page');

        if (newNextLink) {
          nextLink = newNextLink;
        } else {
          nextLink = null;
          observer.disconnect();
        }
      } else {
        nextLink = null;
        observer.disconnect();
      }
    } catch (error) {
      console.error('NEF Infinite Scroll:', error);
    } finally {
      loading = false;
      loader.style.display = 'none';
    }
  }

  const sentinel = document.createElement('div');
  sentinel.id = 'nef-infinite-sentinel';
  sentinel.style.height = '1px';

  pagination.parentNode.insertBefore(sentinel, pagination);

  const observer = new IntersectionObserver(
    function (entries) {
      if (entries[0].isIntersecting) {
        loadMoreProducts();
      }
    },
    {
      rootMargin: '600px 0px'
    }
  );

  observer.observe(sentinel);

  pagination.style.display = 'none';
});